import { inject, Injectable, signal } from '@angular/core';
import { map, catchError, throwError } from 'rxjs';
import { ServerResponse, SOAPRequest } from '../models/model';
import { BankDataResponse, UpdateBankPayloadObject, ZwsBankDataAddResponse, ZwsBankDataUpdateResponse } from '../models/bank.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AddCardRequest, CardApiresponse, CreditCardActions, CreditCardItem, ZwsFmSsCreditCardReAddResponse, ZWSFMSSCREDITCARDUPDATEResponse } from '../models/card.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
http = inject(HttpClient);
 selectedCreditCard = signal<{action:CreditCardActions,card:CreditCardItem} | null>(null);
  /**
 * signal which sets the updated creditcard which is selected for edit or delete operation
 */
  updateCreditCard(action:CreditCardActions,card: CreditCardItem) {
    this.selectedCreditCard.set({action,card});
  }


 /**
 * service call to fetch the bank details from api 
 */
    getBankDetails() {
      return this.http
        .get<BankDataResponse>(
          `${environment.apiUrl}/payment/bank-info`,
          { withCredentials: true }
        )
        .pipe(
          map((response:BankDataResponse) => {
            if(response.ZWS_FM_SS_BANKDATA_GETLISTResponse.ET_BANK_DATA){
              return response.ZWS_FM_SS_BANKDATA_GETLISTResponse.ET_BANK_DATA
            }  
            else{
            throw Error 
            }      
          }),
          catchError((err) => throwError(() => err))
        );
    }
      /**
 * service call to add bank account
 */
    addBankDetails(payload: UpdateBankPayloadObject) {
      const requestBody: SOAPRequest = {
        payload
      };
      return this.http
        .post<ZwsBankDataAddResponse>(
          `${environment.apiUrl}/payment/create-bank-info`,
          requestBody,
          { withCredentials: true }
        )
        .pipe(
          map((response:ZwsBankDataAddResponse) => {
            if(response.ZWS_FM_SS_BANKDATA_ADDResponse.ET_MESSAGES.item){
              return response.ZWS_FM_SS_BANKDATA_ADDResponse.ET_MESSAGES.item
            } 
            else if(response.ZWS_FM_SS_BANKDATA_ADDResponse.ET_RETURN.item){
              return response.ZWS_FM_SS_BANKDATA_ADDResponse.ET_RETURN.item
            } 
            else{
            throw Error 
            }     
          }),
          catchError((err) => throwError(() => err))
        );
    }
      /**
 * service call to update the bank details if already one is added for the user
 */
    updateBankDetails(payload: UpdateBankPayloadObject) {
      const requestBody: SOAPRequest = {
        payload
        
      };
      return this.http
        .put<ZwsBankDataUpdateResponse>(
          `${environment.apiUrl}/payment/update-bank-info`,
          requestBody,
          { withCredentials: true }
        )
        .pipe(
          map((response:ZwsBankDataUpdateResponse) => {
            if(response.ZWS_FM_SS_BANKDATA_UPDATEResponse.ET_MESSAGES.item){
              return response.ZWS_FM_SS_BANKDATA_UPDATEResponse.ET_MESSAGES.item
            } 
             else if(response.ZWS_FM_SS_BANKDATA_UPDATEResponse.ET_RETURN?.item){
              return response.ZWS_FM_SS_BANKDATA_UPDATEResponse.ET_RETURN.item
            }  
            else{
            throw Error 
            }      
          }),
          catchError((err) => throwError(() => err))
        );
    }
      /**
 * service call to fetch the credit cards added for an user
 */
     getCreditCards() {
      return this.http
        .get<CardApiresponse>(
          `${environment.apiUrl}/card/credit-card`,
          { withCredentials: true }
        )
        .pipe(
          map((response:CardApiresponse) => {
            if(response.ZWS_FM_SS_CREDITCARD_GETLISTResponse.ET_CCARD_LIST.item){
              return response.ZWS_FM_SS_CREDITCARD_GETLISTResponse
            }  
            else if(response.ZWS_FM_SS_CREDITCARD_GETLISTResponse.ET_RETURN?.item){
              return response.ZWS_FM_SS_CREDITCARD_GETLISTResponse
            }  
            else{
            throw Error 
            }      
          }),
          catchError((err) => throwError(() => err))
        );
    }
      /**
 * service call to save the credit card to SAP
 */
     saveTokenisedCard(payload: AddCardRequest) {
      const requestBody: SOAPRequest = {
        payload
      };
      return this.http
        .post<ZwsFmSsCreditCardReAddResponse>(
          `${environment.apiUrl}/card/create-credit-card`,
          requestBody,
          { withCredentials: true }
        )
        .pipe(
          map((response:ZwsFmSsCreditCardReAddResponse) => {
            if(response.ZWS_FM_SS_CREDITCARD_READDResponse){
              return response.ZWS_FM_SS_CREDITCARD_READDResponse
            }
            else{
            throw Error 
            }      
          }),
          catchError((err) => throwError(() => err))
        );
    }
      /**
 * service call to update or delete a credit card
 * @action if action is C it will update, D means delete
 */
    updateorDeleteCard(payload: AddCardRequest) {
      const requestBody: SOAPRequest = {
        payload
      };
      return this.http
        .put<ZWSFMSSCREDITCARDUPDATEResponse>(
          `${environment.apiUrl}/card/update-credit-card`,
          requestBody,
          { withCredentials: true }
        )
        .pipe(
          map((response:ZWSFMSSCREDITCARDUPDATEResponse) => {
            if(response.ZWS_FM_SS_CREDITCARD_UPDATEResponse){
              return response.ZWS_FM_SS_CREDITCARD_UPDATEResponse
            }
            else{
            throw Error 
            }      
          }),
          catchError((err) => throwError(() => err))
        );
    }

    getPaymetricPayload(){
          //console.log('getPaymetricPayload called');
          return this.http.get<ServerResponse>(`${environment.apiUrl}/paymetric/payload`, {
            withCredentials: true,
            responseType: 'json'
          })
          .pipe(
            map((response: ServerResponse) => {
              //console.log('Paymetric payload response:', response); 
              return response.payload;
            }),
            catchError((error) => {
                console.error('Error fetching Paymetric payload:', error);
                throw new Error('Failed to fetch Paymetric payload');
            })
          );
        }

}



